<div class="flex flex-column justify-content-evenly">
    <div *ngIf="allies.length > 0">
        <div class="w-10 m-auto">
            <h3 class="text-center">Aliados de MuyComplacientes</h3>
            <p class="text-justify">A continuación, algunos aliados similares y recomendados que también ayudan a crecer y forman parte de la comunidad de MuyComplacientes:</p>
        </div>
        <div class="w-10 m-auto my-3">
            <div *ngFor="let ally of allies" class="m-auto">
                <h3 class="text-center">{{ ally }}</h3>
                <div class="flex flex-column align-items-center">
                    <span [innerHTML]="allyBanners[ally]"></span>
                </div>
            </div>
        </div>
    </div>
</div>